import * as fromActions from '../actions';
import { GenericValidateResponse, GenericUploadResponse } from '../../models/generic-bulk-upsert.model';

export interface GenericBulkUpsertState {
  validating: boolean;
  uploading: boolean;
  validationResponse: GenericValidateResponse | null;
  uploadResponse: GenericUploadResponse | null;
  selectedFile: File | null;
  error: any;
}

export const initialState: GenericBulkUpsertState = {
  validating: false,
  uploading: false,
  validationResponse: null,
  uploadResponse: null,
  selectedFile: null,
  error: null
};

export function reducer(state = initialState, action: fromActions.GenericBulkUpsertActions): GenericBulkUpsertState {
  switch (action.type) {
    case fromActions.GenericBulkUpsertActionTypes.ValidateFile: {
      return {
        ...state,
        validating: true,
        validationResponse: null,
        error: null,
        selectedFile: action.payload.file
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.ValidateFileSuccess: {
      return {
        ...state,
        validating: false,
        validationResponse: action.payload,
        error: null
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.ValidateFileFailure: {
      return {
        ...state,
        validating: false,
        validationResponse: null,
        error: action.payload
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.UploadFile: {
      return {
        ...state,
        uploading: true,
        uploadResponse: null,
        error: null
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.UploadFileSuccess: {
      return {
        ...state,
        uploading: false,
        uploadResponse: action.payload,
        error: null
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.UploadFileFailure: {
      return {
        ...state,
        uploading: false,
        uploadResponse: null,
        error: action.payload
      };
    }

    case fromActions.GenericBulkUpsertActionTypes.ResetState: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}
